export default __webpack_public_path__ + "static/media/account-book.b57c944e.svg";